import { useEffect, useRef, useState } from 'react';

import type { CardDef } from '../game/config/cards';
import { CARD_PACK_PRICES, type CardPackType } from './cardCollectionStore';

interface ShopProps {
  coins: number;
  onBack: () => void;
  onBuyPack: (packType: CardPackType) => CardDef | null;
}

export function Shop({ coins, onBack, onBuyPack }: ShopProps) {
  const [openingPack, setOpeningPack] = useState<CardPackType | null>(null);
  const [revealedCard, setRevealedCard] = useState<CardDef | null>(null);
  const [error, setError] = useState<string>('');
  const timerRef = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    },
    [],
  );

  const handleBuyPack = (packType: CardPackType) => {
    if (openingPack) return;

    const card = onBuyPack(packType);
    if (!card) {
      setError('Not enough coins for this pack.');
      return;
    }

    setError('');
    setOpeningPack(packType);
    setRevealedCard(null);

    timerRef.current = window.setTimeout(() => {
      setRevealedCard(card);
      setOpeningPack(null);
    }, 550);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        maxWidth: 480,
        margin: '0 auto',
        padding: 16,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
      }}
    >
      <button type="button" onClick={onBack} style={{ alignSelf: 'flex-start' }}>
        ← Back
      </button>
      <h2 style={{ margin: 0 }}>Shop</h2>
      <div style={{ background: '#16213e', border: '1px solid #2f3f6b', borderRadius: 12, padding: 12 }}>🪙 Coins: {coins}</div>

      <div style={{ display: 'grid', gap: 10 }}>
        <button
          type="button"
          onClick={() => handleBuyPack('common')}
          disabled={coins < CARD_PACK_PRICES.common || openingPack !== null}
          style={{ padding: 14, borderRadius: 12 }}
        >
          📦 Common Pack — {CARD_PACK_PRICES.common} coins
        </button>
        <button
          type="button"
          onClick={() => handleBuyPack('rare')}
          disabled={coins < CARD_PACK_PRICES.rare || openingPack !== null}
          style={{ padding: 14, borderRadius: 12 }}
        >
          🎁 Rare Pack — {CARD_PACK_PRICES.rare} coins
        </button>
      </div>

      {error && <div style={{ color: '#ff8e8e' }}>{error}</div>}

      <div style={{ marginTop: 8, minHeight: 180, background: '#16213e', border: '1px solid #2f3f6b', borderRadius: 12, padding: 16 }}>
        {!openingPack && !revealedCard && <div style={{ color: '#9fb3d8' }}>Buy a pack to reveal a card.</div>}

        {openingPack && <div style={{ textAlign: 'center', fontSize: 22 }}>Opening {openingPack} pack...</div>}

        {revealedCard && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 44 }}>{revealedCard.icon}</div>
            <strong>{revealedCard.name}</strong>
            <div style={{ marginTop: 6, color: '#9fb3d8' }}>{revealedCard.description}</div>
            <div style={{ marginTop: 10, color: '#ffca59' }}>{revealedCard.rarity.toUpperCase()}</div>
          </div>
        )}
      </div>
    </div>
  );
}
